import { render, staticRenderFns } from "./Fpga.vue?vue&type=template&id=0399ac90&scoped=true&lang=html&"
import script from "./Fpga.vue?vue&type=script&lang=js&"
export * from "./Fpga.vue?vue&type=script&lang=js&"
import style0 from "./Fpga.vue?vue&type=style&index=0&id=0399ac90&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0399ac90",
  null
  
)

export default component.exports